import { OverlayTrigger, Popover } from 'react-bootstrap';
import {
    PasswordTooltipContainerStyled,
    PasswordTooltipRequirementStyled,
    PopoverArrowStyled,
} from './styled/PasswordTooltipStyled';
import { BinIcon } from '../icon/Icon';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getPasswordMinLengthSelector } from '../../app/appSelectors';
import { PASSWORD_CHECK_PARAMS } from '../../app/appConstants';
import {memo, useMemo} from 'react';
import { checkIsPasswordValidWithParams } from '../../app/appUtils';
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

const PasswordRequirement = ({ children, isValid }) => (
    <PasswordTooltipRequirementStyled>
        <BinIcon
            name="IcCheckMark"
            style={{
                fontSize: '16px',
                marginRight: '6px',
                fill: isValid ? 'var(--color-green-secondary)' : 'var(--color-secondary-active)',
            }}
        />
        <div style={{ color: isValid ? 'var(--text-color-secondary)' : 'var(--color-white)' }}>
            {children}
        </div>
    </PasswordTooltipRequirementStyled>
);

const PasswordTooltip = memo(({ children, passwordMinLength, password, show }) => {
    const { getLangPath } = useLangContext();
    const isLengthRequirementValid = useMemo(() => password.length >= passwordMinLength, [password, passwordMinLength]);
    const isLettersRequirementValid = useMemo(() => checkIsPasswordValidWithParams(password, [
        PASSWORD_CHECK_PARAMS.letters,
    ]), [password]);
    const isNumberRequirementValid = useMemo(() => checkIsPasswordValidWithParams(password, [
        PASSWORD_CHECK_PARAMS.number
    ]), [password]);
    return <OverlayTrigger
            show={show}
            flip
            placement="top-start"
            overlay={(props) => {
                return (
                    <Popover {...props} arrowProps={{ style: { display: 'none' } }}>
                        <PopoverArrowStyled
                            className="popover-arrow"
                            {...props.arrowProps}
                            style={{ transform: 'translateX(10px)' }}
                        />
                        <PasswordTooltipContainerStyled>
                            <p style={{ marginBottom: 0 }}>{getLangPath('password.should_contain')}</p>
                            <PasswordRequirement isValid={isLengthRequirementValid}>
                                {getLangPath('password.characters', { count: passwordMinLength })}
                            </PasswordRequirement>
                            <PasswordRequirement isValid={isLettersRequirementValid}>
                                {getLangPath('password.letters')}
                            </PasswordRequirement>
                            <PasswordRequirement isValid={isNumberRequirementValid}>
                                {getLangPath('password.number')}
                            </PasswordRequirement>
                        </PasswordTooltipContainerStyled>
                    </Popover>
                );
            }}
        >
            {children}
        </OverlayTrigger>;
});

const mapStateToProps = createStructuredSelector({
    passwordMinLength: getPasswordMinLengthSelector,
});

export default connect(mapStateToProps)(PasswordTooltip)
